import React from "react";
import { toast } from "react-hot-toast";
import { AiOutlineClose } from "react-icons/ai";

const makeToast = ({ label, type = "success" }) => {
  if (type === "success" || type === "error") {
    toast[type]((t) => (
      <span className="flex items-center gap-2">
        <span>{label || "Oops, something went wrong"}</span>
        <button onClick={() => toast.dismiss(t.id)}>
          <AiOutlineClose />
        </button>
      </span>
    ));
  }
};

export default makeToast;
